var exports = {
  "HG": "xfd349460--49df10--builder-call-reasons",
  "Qs": "xfd349460--49df10--content",
  "wx": "xfd349460--49df10--header",
  "Kk": "xfd349460--49df10--icon",
  "Ot": "xfd349460--49df10--reasons",
  "l": "xfd349460--49df10--reason",
  "o1": "xfd349460--49df10--actions",
};

module.exports = exports;
